import axiosInstance, { ApiKeys, getApiUrl, logError } from '@cp/src/utils/ApiHelper';
import { IAllBankAccountDetails } from './interface';

export const getAllBankAccountDetails = async (
  customerReferenceId: string
): Promise<IAllBankAccountDetails[]> => {
  const url = getApiUrl(ApiKeys.PAYMENT_INSTRUMENTS, { customerReferenceId });
  try {
    const res = await axiosInstance.get(url);
    return res.data;
  } catch (error) {
    logError('Error while fetching bank details');
    return [];
  }
};
